export const adminTitle = '../../src/shared/intl:admin.title';
export const adminTitleOther = '../../src/shared/intl:admin.title.other';
export const forbidden = '../../src/shared/intl:forbidden';
export const itemTitle = '../../src/shared/intl:item.title';
export const itemsTitle = '../../src/shared/intl:items.title';
export const homePublicTitle = '../../src/shared/intl:home.public.title';
export const homeTitle = '../../src/shared/intl:home.title';
export const page2Title = '../../src/shared/intl:page2.title';
export const homepage = '../../src/shared/intl:homepage';
export const title = '../../src/shared/intl:title';
export const name = '../../src/shared/intl:name';
export const noMatch = '../../src/shared/intl:noMatch';
export const missingRouteParam = '../../src/shared/intl:missingRouteParam';
export const confirmModalTitleRemoveItem = '../../src/shared/intl:confirmModalTitleRemoveItem';
export const confirmModalBodyRemoveItem = '../../src/shared/intl:confirmModalBodyRemoveItem';
export const loggedUser = '../../src/shared/intl:loggedUser';
export const login = '../../src/shared/intl:login';
export const logout = '../../src/shared/intl:logout';
export const confirm = '../../src/shared/intl:confirm';
export const save = '../../src/shared/intl:save';
export const saveSuccess = '../../src/shared/intl:saveSuccess';
export const saveError = '../../src/shared/intl:saveError';
export const copySuccess = '../../src/shared/intl:copySuccess';
export const chooseFile = '../../src/shared/intl:chooseFile';
export const add = '../../src/shared/intl:add';
export const ok = '../../src/shared/intl:ok';
export const all = '../../src/shared/intl:all';
export const loadingText = '../../src/shared/intl:loadingText';
export const reservations = '../../src/shared/intl:reservations';
export const resource = '../../src/shared/intl:resource';
export const products = '../../src/shared/intl:products';
export const back = '../../src/shared/intl:back';
export const cancel = '../../src/shared/intl:cancel';
export const submit = '../../src/shared/intl:submit';
export const remove = '../../src/shared/intl:remove';
export const print = '../../src/shared/intl:print';
export const copy = '../../src/shared/intl:copy';
export const createNew = '../../src/shared/intl:createNew';
export const search = '../../src/shared/intl:search';
export const doSearch = '../../src/shared/intl:doSearch';
export const choose = '../../src/shared/intl:choose';
export const addValue = '../../src/shared/intl:addValue';
export const accept = '../../src/shared/intl:accept';
export const edit = '../../src/shared/intl:edit';
export const preview = '../../src/shared/intl:preview';
export const rowsPerPage = '../../src/shared/intl:rowsPerPage';
export const actions = '../../src/shared/intl:actions';
export const todayProgramTitle = '../../src/shared/intl:today.program.title';
export const notes = '../../src/shared/intl:notes';
export const calendar = '../../src/shared/intl:calendar';
export const reminderTitle = '../../src/shared/intl:reminder.title';
export const reminderNone = '../../src/shared/intl:reminder.none';
export const recentEditsTitle = '../../src/shared/intl:recent.edits.title';
export const recentEditsNone = '../../src/shared/intl:recent.edits.none';
export const reminderTableDate = '../../src/shared/intl:reminder.table.date';
export const reminderGroupName = '../../src/shared/intl:reminder.group.name';
export const reminderResourceName = '../../src/shared/intl:reminder.resource.name';
export const reminderProductName = '../../src/shared/intl:reminder.product.name';
export const newsletterTitle = '../../src/shared/intl:newsletter.title';
export const newsletterNone = '../../src/shared/intl:newsletter.none';
export const newsletterReadMore = '../../src/shared/intl:newsletter.read.more';
export const newsletterSingle = '../../src/shared/intl:newsletter.single';
export const newsletterEdit = '../../src/shared/intl:newsletter.edit';
export const newsletterAddPage = '../../src/shared/intl:newsletter.add.page';
export const newsletterAddTitle = '../../src/shared/intl:newsletter.add.title';
export const newsletterAddName = '../../src/shared/intl:newsletter.add.name';
export const newsletterAddBodyText = '../../src/shared/intl:newsletter.add.body.text';
export const newsletterAddExpiration = '../../src/shared/intl:newsletter.add.expiration';
export const newsletterDeleteButton = '../../src/shared/intl:newsletter.delete.button';
export const newsletterDeleteTitle = '../../src/shared/intl:newsletter.delete.title';
export const newsletterDeleteBody = '../../src/shared/intl:newsletter.delete.body';
export const newsletterDeleteYes = '../../src/shared/intl:newsletter.delete.yes';
export const newsletterDeleteNo = '../../src/shared/intl:newsletter.delete.no';
export const dialogTitle = '../../src/shared/intl:dialogTitle';
export const chooseMuseum = '../../src/shared/intl:chooseMuseum';
export const gosta = '../../src/shared/intl:gosta';
export const gustaf = '../../src/shared/intl:gustaf';
export const basics = '../../src/shared/intl:basics';
export const newProduct = '../../src/shared/intl:newProduct';
export const product = '../../src/shared/intl:product';
export const editProduct = '../../src/shared/intl:editProduct';
export const productType = '../../src/shared/intl:productType';
export const productName = '../../src/shared/intl:productName';
export const length = '../../src/shared/intl:length';
export const description = '../../src/shared/intl:description';
export const pricingInformation = '../../src/shared/intl:pricingInformation';
export const price = '../../src/shared/intl:price';
export const showProduct = '../../src/shared/intl:showProduct';
export const resourceNeeded = '../../src/shared/intl:resourceNeeded';
export const status = '../../src/shared/intl:status';
export const limited = '../../src/shared/intl:limited';
export const timeSpan = '../../src/shared/intl:timeSpan';
export const productIcon = '../../src/shared/intl:productIcon';
export const additionalInfo = '../../src/shared/intl:additionalInfo';
export const maxReservations = '../../src/shared/intl:maxReservations';
export const maxGroupSize = '../../src/shared/intl:maxGroupSize';
export const maxGroupSizeTotal = '../../src/shared/intl:maxGroupSizeTotal';
export const active = '../../src/shared/intl:ACTIVE';
export const passive = '../../src/shared/intl:PASSIVE';
export const newResource = '../../src/shared/intl:newResource';
export const editResource = '../../src/shared/intl:editResource';
export const addProduct = '../../src/shared/intl:addProduct';
export const goOpastukset = '../../src/shared/intl:GO_OPASTUKSET';
export const goTilavuokraus = '../../src/shared/intl:GO_TILAVUOKRAUS';
export const goTilavaraus = '../../src/shared/intl:GO_TILAVARAUS';
export const goRavintola = '../../src/shared/intl:GO_RAVINTOLA';
export const goKoululais = '../../src/shared/intl:GO_KOULULAIS';
export const goMuut = '../../src/shared/intl:GO_MUUT';
export const guOpastukset = '../../src/shared/intl:GU_OPASTUKSET';
export const guTilavuokraus = '../../src/shared/intl:GU_TILAVUOKRAUS';
export const guTilavaraus = '../../src/shared/intl:GU_TILAVARAUS';
export const guRavintola = '../../src/shared/intl:GU_RAVINTOLA';
export const guKoululais = '../../src/shared/intl:GU_KOULULAIS';
export const guMuut = '../../src/shared/intl:GU_MUUT';
export const manttaOpastukset = '../../src/shared/intl:MANTTA_OPASTUKSET';
export const erikoisohjelmat = '../../src/shared/intl:ERIKOISOHJELMAT';
export const henkilopalvelut = '../../src/shared/intl:HENKILOPALVELUT';
export const muutKohteet = '../../src/shared/intl:MUUT_KOHTEET';
export const resources = '../../src/shared/intl:resources';
export const fullName = '../../src/shared/intl:fullName';
export const homeAddress = '../../src/shared/intl:homeAddress';
export const postalNumber = '../../src/shared/intl:postalNumber';
export const postOffice = '../../src/shared/intl:postOffice';
export const email = '../../src/shared/intl:email';
export const resourceTitle = '../../src/shared/intl:resourceTitle';
export const resourceType = '../../src/shared/intl:resourceType';
export const role = '../../src/shared/intl:role';
export const myyntipalvelu = '../../src/shared/intl:myyntipalvelu';
export const asiakaspalvelu = '../../src/shared/intl:asiakaspalvelu';
export const muu = '../../src/shared/intl:muu';
export const permanent = '../../src/shared/intl:PERMANENT';
export const partTime = '../../src/shared/intl:PART_TIME';
export const freelancer = '../../src/shared/intl:FREELANCER';
export const qualifications = '../../src/shared/intl:qualifications';
export const qualification = '../../src/shared/intl:qualification';
export const productDialogTitle = '../../src/shared/intl:productDialogTitle';
export const addQualification = '../../src/shared/intl:addQualification';
export const language = '../../src/shared/intl:language';
export const languages = '../../src/shared/intl:languages';
export const accountable = '../../src/shared/intl:accountable';
export const editQualifications = '../../src/shared/intl:editQualifications';
export const fi = '../../src/shared/intl:FI';
export const sv = '../../src/shared/intl:SV';
export const en = '../../src/shared/intl:EN';
export const de = '../../src/shared/intl:DE';
export const fr = '../../src/shared/intl:FR';
export const ru = '../../src/shared/intl:RU';
export const it = '../../src/shared/intl:IT';
export const es = '../../src/shared/intl:ES';
export const fiSimplified = '../../src/shared/intl:FI_SIMPLIFIED';
export const other = '../../src/shared/intl:OTHER';
export const detailedSearch = '../../src/shared/intl:detailedSearch';
export const newReservation = '../../src/shared/intl:newReservation';
export const editReservation = '../../src/shared/intl:editReservation';
export const reservationName = '../../src/shared/intl:reservationName';
export const reservationVisitingTime = '../../src/shared/intl:reservationVisitingTime';
export const reservationSize = '../../src/shared/intl:reservationSize';
export const groupSize = '../../src/shared/intl:groupSize';
export const groupDivision = '../../src/shared/intl:groupDivision';
export const group = '../../src/shared/intl:group';
export const groupColorHex = '../../src/shared/intl:groupColorHex';
export const reservationType = '../../src/shared/intl:reservationType';
export const addNewGroup = '../../src/shared/intl:addNewGroup';
export const addNewVisitingTime = '../../src/shared/intl:addNewVisitingTime';
export const addPhoneNumber = '../../src/shared/intl:addPhoneNumber';
export const addProgramItem = '../../src/shared/intl:addProgramItem';
export const chosen = '../../src/shared/intl:chosen';
export const accepted = '../../src/shared/intl:accepted';
export const kotimainenMyyja = '../../src/shared/intl:KOTIMAINEN_MYYJA';
export const ammattimatkanjarjestaja = '../../src/shared/intl:AMMATTIMATKANJARJESTAJA';
export const koulu = '../../src/shared/intl:KOULU';
export const yritys = '../../src/shared/intl:YRITYS';
export const yksityishenkilo = '../../src/shared/intl:YKSITYISHENKILO';
export const muut = '../../src/shared/intl:MUUT';
export const sisainen = '../../src/shared/intl:SISAINEN';
export const reactionToReservation = '../../src/shared/intl:reactionToReservation';
export const accountables = '../../src/shared/intl:accountables';
export const organizationName = '../../src/shared/intl:organizationName';
export const firstName = '../../src/shared/intl:firstName';
export const lastName = '../../src/shared/intl:lastName';
export const jobTitle = '../../src/shared/intl:jobTitle';
export const username = '../../src/shared/intl:username';
export const phoneNumber = '../../src/shared/intl:phoneNumber';
export const reservationCategory = '../../src/shared/intl:reservationCategory';
export const varaaja = '../../src/shared/intl:VARAAJA';
export const isanta = '../../src/shared/intl:ISANTA';
export const laskutus = '../../src/shared/intl:LASKUTUS';
export const media = '../../src/shared/intl:MEDIA';
export const seniori = '../../src/shared/intl:SENIORI';
export const opettaja = '../../src/shared/intl:OPETTAJA';
export const museo = '../../src/shared/intl:MUSEO';
export const taiteilija = '../../src/shared/intl:TAITEILIJA';
export const suoma = '../../src/shared/intl:SUOMA';
export const kumppani = '../../src/shared/intl:KUMPPANI';
export const manttalahtoinen = '../../src/shared/intl:MANTTALAHTOINEN';
export const matkanjarjestaja = '../../src/shared/intl:MATKANJARJESTAJA';
export const creatingNewContact = '../../src/shared/intl:creatingNewContact';
export const contactFirstName = '../../src/shared/intl:contactFirstName';
export const contactLastName = '../../src/shared/intl:contactLastName';
export const accountableResourceName = '../../src/shared/intl:accountableResourceName';
export const ryhmanvetaja = '../../src/shared/intl:RYHMANVETAJA';
export const laskutettava = '../../src/shared/intl:LASKUTETTAVA';
export const offerBases = '../../src/shared/intl:offerBases';
export const dateAbbr = '../../src/shared/intl:dateAbbr';
export const offer = '../../src/shared/intl:offer';
export const mypa = '../../src/shared/intl:mypa';
export const billing = '../../src/shared/intl:billing';
export const ebilling = '../../src/shared/intl:ebilling';
export const restaurant = '../../src/shared/intl:restaurant';
export const customerDocumentation = '../../src/shared/intl:customerDocumentation';
export const showInfo = '../../src/shared/intl:showInfo';
export const program = '../../src/shared/intl:program';
export const report = '../../src/shared/intl:report';
export const sendingInfo = '../../src/shared/intl:sendingInfo';
export const send = '../../src/shared/intl:send';
export const editableBases = '../../src/shared/intl:editableBases';
export const sentDocuments = '../../src/shared/intl:sentDocuments';
export const sendDialogContentTitle = '../../src/shared/intl:sendDialogContentTitle';
export const sendDialogFormDirty = '../../src/shared/intl:sendDialogFormDirty';
export const sendDialogContent = '../../src/shared/intl:sendDialogContent';
export const coverLetter = '../../src/shared/intl:coverLetter';
export const sender = '../../src/shared/intl:sender';
export const recipients = '../../src/shared/intl:recipients';
export const person = '../../src/shared/intl:person';
export const addNewPerson = '../../src/shared/intl:addNewPerson';
export const editOffer = '../../src/shared/intl:editOffer';
export const content = '../../src/shared/intl:content';
export const actualisedGroupSize = '../../src/shared/intl:actualisedGroupSize';
export const payingVisitors = '../../src/shared/intl:payingVisitors';
export const freeTickets = '../../src/shared/intl:freeTickets';
export const actualisedPrice = '../../src/shared/intl:actualisedPrice';
export const reportFromVisitation = '../../src/shared/intl:reportFromVisitation';
export const addProgramItemTitle = '../../src/shared/intl:addProgramItemTitle';
export const editProgramItemTitle = '../../src/shared/intl:editProgramItemTitle';
export const editProgramItemInfo = '../../src/shared/intl:editProgramItemInfo';
export const dropZoneDropOrClick = '../../src/shared/intl:dropZoneDropOrClick';
export const dropZoneDrop = '../../src/shared/intl:dropZoneDrop';
export const confirmModalTitleFileAdd = '../../src/shared/intl:confirmModalTitleFileAdd';
export const confirmModalBodyFileAdd = '../../src/shared/intl:confirmModalBodyFileAdd';
export const confirmModalTitleFileRemove = '../../src/shared/intl:confirmModalTitleFileRemove';
export const confirmModalBodyFileRemove = '../../src/shared/intl:confirmModalBodyFileRemove';
export const settings = '../../src/shared/intl:settings';
export const maintenance = '../../src/shared/intl:maintenance';
export const reindexAll = '../../src/shared/intl:reindexAll';
export const indexSuccess = '../../src/shared/intl:indexSuccess';
export const indexError = '../../src/shared/intl:indexError';
export const usersAdmin = '../../src/shared/intl:usersAdmin';
export const emptyDataSourceMessage = '../../src/shared/intl:emptyDataSourceMessage';
export const notfound = '../../src/shared/intl:notfound';
export const notFoundBody = '../../src/shared/intl:notFoundBody';
export const otherError = '../../src/shared/intl:otherError';
export const newsletterTitleRequired = '../../src/shared/intl:newsletterTitleRequired';
export const newsletterBodyRequired = '../../src/shared/intl:newsletterBodyRequired';
export const productNameRequired = '../../src/shared/intl:productNameRequired';
export const productLengthRequired = '../../src/shared/intl:productLengthRequired';
export const productTypeRequired = '../../src/shared/intl:productTypeRequired';
export const productIconRequired = '../../src/shared/intl:productIconRequired';
export const resourceNameRequired = '../../src/shared/intl:resourceNameRequired';
export const resourceUsernameRequired = '../../src/shared/intl:resourceUsernameRequired';
export const resourceUsernameNoSpaces = '../../src/shared/intl:resourceUsernameNoSpaces';
export const resourceEmailRequired = '../../src/shared/intl:resourceEmailRequired';
export const resourceValidEmail = '../../src/shared/intl:resourceValidEmail';
export const resourceRoleRequired = '../../src/shared/intl:resourceRoleRequired';
export const uniqueResourceError = '../../src/shared/intl:uniqueResourceError';
export const reservationNameRequired = '../../src/shared/intl:reservationNameRequired';
export const reservationTypeRequired = '../../src/shared/intl:reservationTypeRequired';
export const reservationSizeRequired = '../../src/shared/intl:reservationSizeRequired';
export const dateProductsLimited = '../../src/shared/intl:dateProductsLimited';
export const groupRequired = '../../src/shared/intl:groupRequired';
export const groupTooLarge = '../../src/shared/intl:groupTooLarge';
export const groupNumberTooLarge = '../../src/shared/intl:groupNumberTooLarge';
export const groupSizeMismatch = '../../src/shared/intl:groupSizeMismatch';
export const productRequired = '../../src/shared/intl:productRequired';
export const productLimited = '../../src/shared/intl:productLimited';
export const invalidContacts = '../../src/shared/intl:invalidContacts';
export const rejectedFile = '../../src/shared/intl:rejectedFile';
export const fileConflict = '../../src/shared/intl:fileConflict';
export default {adminTitle, adminTitleOther, forbidden, itemTitle, itemsTitle, homePublicTitle, homeTitle, page2Title, homepage, title, name, noMatch, missingRouteParam, confirmModalTitleRemoveItem, confirmModalBodyRemoveItem, loggedUser, login, logout, confirm, save, saveSuccess, saveError, copySuccess, chooseFile, add, ok, all, loadingText, reservations, resource, products, back, cancel, submit, remove, print, copy, createNew, search, doSearch, choose, addValue, accept, edit, preview, rowsPerPage, actions, todayProgramTitle, notes, calendar, reminderTitle, reminderNone, recentEditsTitle, recentEditsNone, reminderTableDate, reminderGroupName, reminderResourceName, reminderProductName, newsletterTitle, newsletterNone, newsletterReadMore, newsletterSingle, newsletterEdit, newsletterAddPage, newsletterAddTitle, newsletterAddName, newsletterAddBodyText, newsletterAddExpiration, newsletterDeleteButton, newsletterDeleteTitle, newsletterDeleteBody, newsletterDeleteYes, newsletterDeleteNo, dialogTitle, chooseMuseum, gosta, gustaf, basics, newProduct, product, editProduct, productType, productName, length, description, pricingInformation, price, showProduct, resourceNeeded, status, limited, timeSpan, productIcon, additionalInfo, maxReservations, maxGroupSize, maxGroupSizeTotal, active, passive, newResource, editResource, addProduct, goOpastukset, goTilavuokraus, goTilavaraus, goRavintola, goKoululais, goMuut, guOpastukset, guTilavuokraus, guTilavaraus, guRavintola, guKoululais, guMuut, manttaOpastukset, erikoisohjelmat, henkilopalvelut, muutKohteet, resources, fullName, homeAddress, postalNumber, postOffice, email, resourceTitle, resourceType, role, myyntipalvelu, asiakaspalvelu, muu, permanent, partTime, freelancer, qualifications, qualification, productDialogTitle, addQualification, language, languages, accountable, editQualifications, fi, sv, en, de, fr, ru, it, es, fiSimplified, other, detailedSearch, newReservation, editReservation, reservationName, reservationVisitingTime, reservationSize, groupSize, groupDivision, group, groupColorHex, reservationType, addNewGroup, addNewVisitingTime, addPhoneNumber, addProgramItem, chosen, accepted, kotimainenMyyja, ammattimatkanjarjestaja, koulu, yritys, yksityishenkilo, muut, sisainen, reactionToReservation, accountables, organizationName, firstName, lastName, jobTitle, username, phoneNumber, reservationCategory, varaaja, isanta, laskutus, media, seniori, opettaja, museo, taiteilija, suoma, kumppani, manttalahtoinen, matkanjarjestaja, creatingNewContact, contactFirstName, contactLastName, accountableResourceName, ryhmanvetaja, laskutettava, offerBases, dateAbbr, offer, mypa, billing, ebilling, restaurant, customerDocumentation, showInfo, program, report, sendingInfo, send, editableBases, sentDocuments, sendDialogContentTitle, sendDialogFormDirty, sendDialogContent, coverLetter, sender, recipients, person, addNewPerson, editOffer, content, actualisedGroupSize, payingVisitors, freeTickets, actualisedPrice, reportFromVisitation, addProgramItemTitle, editProgramItemTitle, editProgramItemInfo, dropZoneDropOrClick, dropZoneDrop, confirmModalTitleFileAdd, confirmModalBodyFileAdd, confirmModalTitleFileRemove, confirmModalBodyFileRemove, settings, maintenance, reindexAll, indexSuccess, indexError, usersAdmin, emptyDataSourceMessage, notfound, notFoundBody, otherError, newsletterTitleRequired, newsletterBodyRequired, productNameRequired, productLengthRequired, productTypeRequired, productIconRequired, resourceNameRequired, resourceUsernameRequired, resourceUsernameNoSpaces, resourceEmailRequired, resourceValidEmail, resourceRoleRequired, uniqueResourceError, reservationNameRequired, reservationTypeRequired, reservationSizeRequired, dateProductsLimited, groupRequired, groupTooLarge, groupNumberTooLarge, groupSizeMismatch, productRequired, productLimited, invalidContacts, rejectedFile, fileConflict};
